import { render, staticRenderFns } from "./WLabel.vue?vue&type=template&id=db76e958&scoped=true&"
import script from "./WLabel.vue?vue&type=script&lang=js&"
export * from "./WLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db76e958",
  null
  
)

export default component.exports